/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/esnext.async-iterator.map.js";
import "core-js/modules/esnext.iterator.map.js";
import { useCreditStore } from '@/stores/modules/credit';
import { useUserStore } from '@/stores/modules/user';
import objToArray from '@/shared/objToArray';
import TrackingData from '@/shared/reportDataTracking';
import SelectPopup from '@/components/select-popup.vue';
import { useCreditCommon, useFormTracking, useRetainPopup } from '@/composables/useCreditCommon.js';
// use composables
export default {
    __name: 'information',
    setup: function(__props) {
        var _useCreditCommon = useCreditCommon(), agreed = _useCreditCommon.agreed, enterTime = _useCreditCommon.enterTime, PrivacyDataBox = _useCreditCommon.PrivacyDataBox;
        var _useFormTracking = useFormTracking(), onClickTrack = _useFormTracking.onClickTrack, onFocusTrack = _useFormTracking.onFocusTrack, onBlurTrack = _useFormTracking.onBlurTrack;
        var _useRetainPopup = useRetainPopup(), CreditFirstRetainPopup = _useRetainPopup.CreditFirstRetainPopup, CreditSecondRetainPopup = _useRetainPopup.CreditSecondRetainPopup, isShowFirstRetainPopup = _useRetainPopup.isShowFirstRetainPopup, isShowSecondRetainPopup = _useRetainPopup.isShowSecondRetainPopup, showSecondRetainPopup = _useRetainPopup.showSecondRetainPopup, goAppHome = _useRetainPopup.goAppHome;
        var router = useRouter();
        var creditStore = useCreditStore();
        var userStore = useUserStore();
        var informationRef = ref();
        var onSubmit = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(val) {
                var params, routeObj;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                taskHandler: 'personal_info_screen-submit',
                                taskState: 1
                            }));
                            console.log('submit information', val);
                            params = {
                                kindSort: 1,
                                coreData: {
                                    learningPath: codeEducation.value,
                                    relationshipState: codeMarry.value,
                                    regionCode: codeState.value,
                                    urbanCode: codeCity.value,
                                    stayPeriod: codeLiveDuration.value,
                                    placeInfo: address.value,
                                    workType: codeWorkType.value,
                                    jobRole: codeIndustry.value,
                                    workRole: codeJobType.value,
                                    jobSpan: codeWorkDuration.value,
                                    revenueStream: codeIncomeSource.value,
                                    payPeriod: codeSalaryPayMode.value,
                                    paymentSchedule: salaryDateList.value.join(','),
                                    // nextSalaryDate: 1,
                                    monthPaycheck: codeSalary.value,
                                    bankId: bankNumber.value,
                                    sureName: accountName.value,
                                    cashMode: codeBankType.value,
                                    cashKey: codeBankName.value
                                }
                            };
                            return [
                                4,
                                creditStore.reqCreditSubmit(params)
                            ];
                        case 1:
                            routeObj = _state.sent();
                            router.push(routeObj);
                            return [
                                2
                            ];
                    }
                });
            });
            return function onSubmit(val) {
                return _ref.apply(this, arguments);
            };
        }();
        var onFailed = function(val) {
            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                taskHandler: 'personal_info_screen-submit',
                taskState: 0,
                growArea: JSON.stringify({
                    msg: val.errors[0].name
                }),
                eventIntervalSpan: new Date() - enterTime.value
            }));
        };
        /**
 * personal info
 */ // education
        var codeEducation = ref('');
        var textEducation = ref('');
        var columnsEducation = ref([]);
        var showPickerEducation = ref(false);
        var onConfirmEducation = function(value) {
            codeEducation.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textEducation.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerEducation.value = false;
        };
        var clickPickerEducation = function() {
            showPickerEducation.value = true;
            onClickTrack('education');
        };
        // marry
        var codeMarry = ref('');
        var textMarry = ref('');
        var columnsMarry = ref([]);
        var showPickerMarry = ref(false);
        var onConfirmMarry = function(value) {
            codeMarry.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textMarry.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerMarry.value = false;
        };
        var clickPickerMarry = function() {
            showPickerMarry.value = true;
            onClickTrack('marital_status');
        };
        // state zhou
        var codeState = ref('');
        var textState = ref('');
        var columnsState = ref([]);
        var showPickerState = ref(false);
        var onConfirmState = function(value) {
            codeState.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textState.value = value === null || value === void 0 ? void 0 : value.worthValue;
            columnsCity.value = value === null || value === void 0 ? void 0 : value.kidGroup;
            codeCity.value = '';
            textCity.value = '';
            showPickerState.value = false;
        };
        var clickPickerState = function() {
            showPickerState.value = true;
            onClickTrack('state');
        };
        // city
        var codeCity = ref('');
        var textCity = ref('');
        var columnsCity = ref([]);
        var showPickerCity = ref(false);
        var onConfirmCity = function(value) {
            codeCity.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textCity.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerCity.value = false;
        };
        var clickPickerCity = function() {
            showPickerCity.value = true;
            onClickTrack('city');
        };
        // live duration
        var codeLiveDuration = ref('');
        var textLiveDuration = ref('');
        var columnsLiveDuration = ref([]);
        var showPickerLiveDuration = ref(false);
        var onConfirmLiveDuration = function(value) {
            codeLiveDuration.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textLiveDuration.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerLiveDuration.value = false;
        };
        var clickPickerLiveDuration = function() {
            showPickerLiveDuration.value = true;
            onClickTrack('residence_time');
        };
        // address
        var address = ref('');
        /**
 * work info
 */ // work type
        var codeWorkType = ref('');
        var textWorkType = ref('');
        var columnsWorkType = ref([]);
        var showPickerWorkType = ref(false);
        var onConfirmWorkType = function(value) {
            codeWorkType.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textWorkType.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerWorkType.value = false;
        };
        var clickPickerWorkType = function() {
            showPickerWorkType.value = true;
            onClickTrack('occupation');
        };
        // industry
        var codeIndustry = ref('');
        var textIndustry = ref('');
        var columnsIndustry = ref([]);
        var showPickerIndustry = ref(false);
        var onConfirmIndustry = function(value) {
            codeIndustry.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textIndustry.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerIndustry.value = false;
        };
        var clickPickerIndustry = function() {
            showPickerIndustry.value = true;
            onClickTrack('industry');
        };
        // job type
        var codeJobType = ref('');
        var textJobType = ref('');
        var columnsJobType = ref([]);
        var showPickerJobType = ref(false);
        var onConfirmJobType = function(value) {
            codeJobType.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textJobType.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerJobType.value = false;
        };
        var clickPickerJobType = function() {
            showPickerJobType.value = true;
            onClickTrack('type_of_job');
        };
        // work duration
        var codeWorkDuration = ref('');
        var textWorkDuration = ref('');
        var columnsWorkDuration = ref([]);
        var showPickerWorkDuration = ref(false);
        var onConfirmWorkDuration = function(value) {
            codeWorkDuration.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textWorkDuration.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerWorkDuration.value = false;
        };
        var clickPickerWorkDuration = function() {
            showPickerWorkDuration.value = true;
            onClickTrack('working_years');
        };
        // incode source
        var codeIncomeSource = ref('');
        var textIncomeSource = ref('');
        var columnsIncomeSource = ref([]);
        var showPickerIncomeSource = ref(false);
        var onConfirmIncomeSource = function(value) {
            codeIncomeSource.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textIncomeSource.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerIncomeSource.value = false;
        };
        var clickPickerIncomeSource = function() {
            showPickerIncomeSource.value = true;
            onClickTrack('source_of_income');
        };
        // pay mode
        var codeSalaryPayMode = ref('');
        var textSalaryPayMode = ref('');
        var columnsSalaryPayMode = ref([]);
        var showPickerSalaryPayMode = ref(false);
        var onConfirmSalaryPayMode = function(value) {
            codeSalaryPayMode.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textSalaryPayMode.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerSalaryPayMode.value = false;
        };
        var clickPickerSalaryPayMode = function() {
            showPickerSalaryPayMode.value = true;
            onClickTrack('salary_payment_method');
        };
        // first salary date
        var salaryDateList = ref([]);
        var showPickerNextSalaryDate = ref(false);
        var onConfirmNextSalaryDate = function(value) {
            salaryDateList.value = value.map(function(item) {
                return item.getDate();
            });
            showPickerNextSalaryDate.value = false;
        };
        var clickPickerNextSalaryDate = function() {
            showPickerNextSalaryDate.value = true;
            onClickTrack('payday');
        };
        // next salary date
        // salary
        var codeSalary = ref('');
        var textSalary = ref('');
        var columnsSalary = ref([]);
        var showPickerSalary = ref(false);
        var onConfirmSalary = function(value) {
            codeSalary.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textSalary.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerSalary.value = false;
        };
        var clickPickerSalary = function() {
            showPickerSalary.value = true;
            onClickTrack('monthly_income');
        };
        // bank type
        var codeBankType = ref('');
        var textBankType = ref('');
        var columnsBankType = ref([]);
        var showPickerBankType = ref(false);
        var onConfirmBankType = function(value) {
            codeBankType.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textBankType.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerBankType.value = false;
            codeBankName.value = '';
            textBankName.value = '';
            bankNumber.value = '';
        };
        var clickPickerBankType = function() {
            showPickerBankType.value = true;
            onClickTrack('payment_methods');
        };
        // bank name
        var codeBankName = ref('');
        var textBankName = ref('');
        var showPickerBankName = ref(false);
        var onConfirmBankName = function(value) {
            codeBankName.value = value === null || value === void 0 ? void 0 : value.mainLock;
            textBankName.value = value === null || value === void 0 ? void 0 : value.worthValue;
            showPickerBankName.value = false;
        };
        var clickPickerBankName = function() {
            showPickerBankName.value = true;
            onClickTrack('bank');
        };
        var bankNumber = ref('');
        var accountName = ref('');
        var columnsBankName = computed(function() {
            return codeBankType.value ? creditStore.bankTypeList.fundKey[codeBankType.value] : [];
        });
        var maxlength = computed(function() {
            return codeBankType.value === 3 ? 18 : 16;
        });
        var patternBankNumber = computed(function() {
            return codeBankType.value === 3 ? /^\d{18}$/ : /^\d{16}$/;
        });
        var initData = function(dictionary) {
            columnsEducation.value = objToArray(dictionary.dataMap.learningPath);
            columnsMarry.value = objToArray(dictionary.dataMap.relationshipState);
            columnsLiveDuration.value = objToArray(dictionary.dataMap.stayPeriod);
            columnsWorkType.value = objToArray(dictionary.dataMap.workType);
            columnsIndustry.value = objToArray(dictionary.dataMap.jobRole);
            columnsJobType.value = dictionary.dataSet.workRole;
            columnsWorkDuration.value = objToArray(dictionary.dataMap.jobSpan);
            columnsIncomeSource.value = dictionary.dataSet.revenueStream;
            columnsSalaryPayMode.value = objToArray(dictionary.dataMap.payPeriod);
            columnsSalary.value = dictionary.dataSet.monthPaycheck;
        };
        var initData2 = function(dictionary) {
            columnsState.value = dictionary.plantStem;
        };
        var initData3 = function(bankTypeList) {
            columnsBankType.value = bankTypeList.cashOption;
        };
        onBeforeMount(function() {
            if (creditStore.dictionary) {
                initData(creditStore.dictionary);
            }
            if (creditStore.provinceDictionary) {
                initData2(creditStore.provinceDictionary);
            }
            if (creditStore.bankTypeList) {
                initData3(creditStore.bankTypeList);
            }
        });
        watch(function() {
            return creditStore.dictionary;
        }, function(newVal) {
            if (newVal) {
                initData(newVal);
            }
        }, {
            immediate: true
        });
        watch(function() {
            return creditStore.provinceDictionary;
        }, function(newVal) {
            if (newVal) {
                initData2(newVal);
            }
        }, {
            immediate: true
        });
        watch(function() {
            return creditStore.bankTypeList;
        }, function(newVal) {
            if (newVal) {
                initData3(newVal);
            }
        }, {
            immediate: true
        });
        return {
            __sfc: true,
            agreed: agreed,
            enterTime: enterTime,
            PrivacyDataBox: PrivacyDataBox,
            onClickTrack: onClickTrack,
            onFocusTrack: onFocusTrack,
            onBlurTrack: onBlurTrack,
            CreditFirstRetainPopup: CreditFirstRetainPopup,
            CreditSecondRetainPopup: CreditSecondRetainPopup,
            isShowFirstRetainPopup: isShowFirstRetainPopup,
            isShowSecondRetainPopup: isShowSecondRetainPopup,
            showSecondRetainPopup: showSecondRetainPopup,
            goAppHome: goAppHome,
            router: router,
            creditStore: creditStore,
            userStore: userStore,
            informationRef: informationRef,
            onSubmit: onSubmit,
            onFailed: onFailed,
            codeEducation: codeEducation,
            textEducation: textEducation,
            columnsEducation: columnsEducation,
            showPickerEducation: showPickerEducation,
            onConfirmEducation: onConfirmEducation,
            clickPickerEducation: clickPickerEducation,
            codeMarry: codeMarry,
            textMarry: textMarry,
            columnsMarry: columnsMarry,
            showPickerMarry: showPickerMarry,
            onConfirmMarry: onConfirmMarry,
            clickPickerMarry: clickPickerMarry,
            codeState: codeState,
            textState: textState,
            columnsState: columnsState,
            showPickerState: showPickerState,
            onConfirmState: onConfirmState,
            clickPickerState: clickPickerState,
            codeCity: codeCity,
            textCity: textCity,
            columnsCity: columnsCity,
            showPickerCity: showPickerCity,
            onConfirmCity: onConfirmCity,
            clickPickerCity: clickPickerCity,
            codeLiveDuration: codeLiveDuration,
            textLiveDuration: textLiveDuration,
            columnsLiveDuration: columnsLiveDuration,
            showPickerLiveDuration: showPickerLiveDuration,
            onConfirmLiveDuration: onConfirmLiveDuration,
            clickPickerLiveDuration: clickPickerLiveDuration,
            address: address,
            codeWorkType: codeWorkType,
            textWorkType: textWorkType,
            columnsWorkType: columnsWorkType,
            showPickerWorkType: showPickerWorkType,
            onConfirmWorkType: onConfirmWorkType,
            clickPickerWorkType: clickPickerWorkType,
            codeIndustry: codeIndustry,
            textIndustry: textIndustry,
            columnsIndustry: columnsIndustry,
            showPickerIndustry: showPickerIndustry,
            onConfirmIndustry: onConfirmIndustry,
            clickPickerIndustry: clickPickerIndustry,
            codeJobType: codeJobType,
            textJobType: textJobType,
            columnsJobType: columnsJobType,
            showPickerJobType: showPickerJobType,
            onConfirmJobType: onConfirmJobType,
            clickPickerJobType: clickPickerJobType,
            codeWorkDuration: codeWorkDuration,
            textWorkDuration: textWorkDuration,
            columnsWorkDuration: columnsWorkDuration,
            showPickerWorkDuration: showPickerWorkDuration,
            onConfirmWorkDuration: onConfirmWorkDuration,
            clickPickerWorkDuration: clickPickerWorkDuration,
            codeIncomeSource: codeIncomeSource,
            textIncomeSource: textIncomeSource,
            columnsIncomeSource: columnsIncomeSource,
            showPickerIncomeSource: showPickerIncomeSource,
            onConfirmIncomeSource: onConfirmIncomeSource,
            clickPickerIncomeSource: clickPickerIncomeSource,
            codeSalaryPayMode: codeSalaryPayMode,
            textSalaryPayMode: textSalaryPayMode,
            columnsSalaryPayMode: columnsSalaryPayMode,
            showPickerSalaryPayMode: showPickerSalaryPayMode,
            onConfirmSalaryPayMode: onConfirmSalaryPayMode,
            clickPickerSalaryPayMode: clickPickerSalaryPayMode,
            salaryDateList: salaryDateList,
            showPickerNextSalaryDate: showPickerNextSalaryDate,
            onConfirmNextSalaryDate: onConfirmNextSalaryDate,
            clickPickerNextSalaryDate: clickPickerNextSalaryDate,
            codeSalary: codeSalary,
            textSalary: textSalary,
            columnsSalary: columnsSalary,
            showPickerSalary: showPickerSalary,
            onConfirmSalary: onConfirmSalary,
            clickPickerSalary: clickPickerSalary,
            codeBankType: codeBankType,
            textBankType: textBankType,
            columnsBankType: columnsBankType,
            showPickerBankType: showPickerBankType,
            onConfirmBankType: onConfirmBankType,
            clickPickerBankType: clickPickerBankType,
            codeBankName: codeBankName,
            textBankName: textBankName,
            showPickerBankName: showPickerBankName,
            onConfirmBankName: onConfirmBankName,
            clickPickerBankName: clickPickerBankName,
            bankNumber: bankNumber,
            accountName: accountName,
            columnsBankName: columnsBankName,
            maxlength: maxlength,
            patternBankNumber: patternBankNumber,
            initData: initData,
            initData2: initData2,
            initData3: initData3,
            SelectPopup: SelectPopup
        };
    }
};
